export interface ModulesCard {
    title: string;
    icon: string;
    link: string;
    notification: number;
  }
export const HomeModules: ModulesCard[] = [
    {
      title: 'Request',
      icon: '/assets/icons/request-icon.png',
      notification: 5,
      link: '/dashboard/requests',
    },
    {
      title: 'Approve',
      icon: '/assets/icons/aprove-icon.png',
      notification: 5,
      link: '/dashboard/approve',
    },
    {
      title: 'History',
      icon: '/assets/icons/history-icon.png',
      notification: 0,
      link: '/dashboard/history',
    },
    {
      title: 'Profile',
      icon: '/assets/icons/client-icon.png',
      notification: 0,
      link: '/dashboard/profile',
    },
  ];